import React from 'react';
import { Modal } from 'react-bootstrap';
import { Row, Col, Spinner } from 'reactstrap';
import './spinner.scss';
export const SpinnerKonecta = () => {
  return (
    <Modal.Body className="modal-body-generic pb-3">
      <Row className="d-flex text-center justify-content-center align-items-center container-spinner mt-5">
        <Col>
          <Spinner className="spinner-app"></Spinner>
        </Col>
      </Row>
    </Modal.Body>
  );
};
